import { IncidentMessage } from '@bybeam/platform-types';
import usePlaceholder from '@platform-ui-common/hooks/usePlaceholder.js';
import Color, { TextColors } from '@platform-ui-common/utilities/Color.js';
import replacePlaceholders, {
  PlaceholderSource,
} from '@platform-ui-common/utilities/placeholder.js';
import { useState } from 'react';
import Markdown from '../Markdown/index.js';
import NotificationBanner from '../NotificationBanner/index.js';

export interface ActiveIncidentsBannerProps {
  incidents: IncidentMessage[];
}

const transformMessage = (message: string, placeholders: PlaceholderSource): JSX.Element => {
  return (
    <div className={TextColors[Color.White]}>
      <Markdown variant="body" alignment="center">
        {replacePlaceholders(message, placeholders)}
      </Markdown>
    </div>
  );
};

export default function ActiveIncidentsBanner({
  incidents,
}: ActiveIncidentsBannerProps): JSX.Element {
  const placeholders = usePlaceholder();
  const [dismissed, setDismissed] = useState<string[]>([]);

  return (
    <>
      {incidents?.map(({ id, message }) =>
        !dismissed.includes(id) ? (
          <NotificationBanner key={id} onDismiss={(): void => setDismissed([...dismissed, id])}>
            {transformMessage(message, placeholders)}
          </NotificationBanner>
        ) : null,
      )}
    </>
  );
}
